import { render, staticRenderFns } from "./houseRelevant.vue?vue&type=template&id=bfc2cef0&scoped=true&"
import script from "./houseRelevant.vue?vue&type=script&lang=js&"
export * from "./houseRelevant.vue?vue&type=script&lang=js&"
import style0 from "./houseRelevant.vue?vue&type=style&index=0&id=bfc2cef0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc2cef0",
  null
  
)

export default component.exports